export default __webpack_public_path__ + "static/media/icn_sprout_sad.03953a92.svg";